import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tab, Tabs } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import { ListarClientesVendaController } from "../../../../Controllers/Cobranca/Proponentes/ProponentesController";
import { GetVendaController } from "../../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IVendaInfo } from "../../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import {
    formatMoneyReais,
    formatPercentual,
} from "../../../../Tools/FormatTools";
import SpinnerUAU from "../../../Loding/SpinnerUAU";
import Table from "../../../Table";
import ParcelasAbertasCard from "../../ParcelasAbertas";
import AnexosVenda from "./AnexosDaVenda";
import InfoCobranca from "./InfoCobranca";
import InfoEscritura from "./InfoEscritura";
import InformacoesErp from "./InformacoesErp";

interface IInformacoesVendaProps {
    showParcelas?: boolean;
    ID_CHAVE_ERP_VENDA: string;
    DS_EMPREENDIMENTO?: string;
    DS_UNIDADE?: string;
    idContaProduto?: number;
}

export default function InformacoesVenda(props: IInformacoesVendaProps) {
    const {
        value: venda,
        loading,
        execute: updateList,
    } = useAsyncEffect(
        () => GetVendaController(props.ID_CHAVE_ERP_VENDA),
        [props.ID_CHAVE_ERP_VENDA]
    );

    return (
        <div>
            <Tabs
                mountOnEnter
                defaultActiveKey={
                    props.showParcelas ? "parcAberto" : "infoGerals"
                }
            >
                {props.showParcelas && (
                    <Tab title="Parcelas em aberto" eventKey="parcAberto">
                        <div className="pt-4">
                            <ParcelasAbertasCard
                                ID_CHAVE_ERP={props.ID_CHAVE_ERP_VENDA}
                                mostrarIndicadores={
                                    props.DS_EMPREENDIMENTO && props.DS_UNIDADE
                                        ? {
                                              DS_PRODUTO:
                                                  props.DS_EMPREENDIMENTO,
                                              DS_UNIDADE: props.DS_UNIDADE,
                                          }
                                        : undefined
                                }
                            />
                        </div>
                    </Tab>
                )}
                <Tab title="Informações Gerais" eventKey="infoGerals">
                    <div className="pt-4">
                        <InformacoesVendaComponent
                            {...props}
                            loading={loading}
                            venda={venda}
                        />
                    </div>
                </Tab>
                {venda?.LstEscrituras && (
                    <Tab title="Status Escritura" eventKey="escritura">
                        <div className="pt-4">
                            <InfoEscritura
                                lstEscriturasIds={venda.LstEscrituras}
                                updateList={updateList}
                                ID_CHAVE_ERP={props.ID_CHAVE_ERP_VENDA}
                                loadingInfoVenda={loading}
                            />
                        </div>
                    </Tab>
                )}
                <Tab title="Anexos da Venda" eventKey="anexosVenda">
                    <AnexosVenda ID_CHAVE_ERP={props.ID_CHAVE_ERP_VENDA} />
                </Tab>
                {props.idContaProduto && (
                    <Tab title="Informações Venda ERP" eventKey="vendaErp">
                        <InformacoesErp idContaProduto={props.idContaProduto} />
                    </Tab>
                )}
            </Tabs>
        </div>
    );
}

function InformacoesVendaComponent(
    props: IInformacoesVendaProps & {
        loading: boolean;
        venda: IVendaInfo | undefined;
    }
) {
    const { loading, venda } = props;

    const { value: Proponentes, loading: ProponentesLoading } = useAsyncEffect(
        async () => ListarClientesVendaController(props.ID_CHAVE_ERP_VENDA)
    );

    return (
        <div>
            {loading ? (
                <SpinnerUAU />
            ) : venda ? (
                <div>
                    <div className="d-flex">
                        <div
                            className={`pr-2 symbol symbol-45 symbol-light-danger`}
                        >
                            <div className="symbol-label">
                                <FontAwesomeIcon icon={faHome} size="lg" />
                            </div>
                        </div>
                        <div>
                            <h6 className="font-weight-bolder mb-0">
                                {props.DS_EMPREENDIMENTO}
                            </h6>
                            <div>{props.DS_UNIDADE}</div>
                            <div>{props.ID_CHAVE_ERP_VENDA}</div>
                        </div>
                    </div>
                    {topicRender.map((tpc) => (
                        <div
                            className="my-5 border rounded p-5"
                            key={tpc.title}
                        >
                            <h6 className="text-center">{tpc.title}</h6>
                            <div className="d-flex flex-wrap g-5 align-tems-center justify-content-evenly">
                                {tpc.data.map((o) => {
                                    let render = venda[o.key];
                                    if (
                                        o.format === "date" &&
                                        typeof render === "string"
                                    )
                                        render = new Date(
                                            render
                                        ).toLocaleDateString();
                                    else if (
                                        o.format === "flag" ||
                                        o.format === "flagLabel"
                                    )
                                        render = render ? "Sim" : "Não";
                                    else if (
                                        o.format === "money" &&
                                        typeof render === "number"
                                    )
                                        render = formatMoneyReais(render);
                                    else if (
                                        o.format === "percentual" &&
                                        typeof render === "number"
                                    )
                                        render = formatPercentual(render);
                                    else if (
                                        o.format !== "date" &&
                                        o.format !== "money" &&
                                        o.format !== "percentual" &&
                                        o.format !== undefined
                                    )
                                        render = o.format(render, venda);

                                    return o.format !== "flagLabel" ? (
                                        <div
                                            className="d-flex flex-column justify-content-center align-items-center"
                                            key={o.key}
                                        >
                                            <span className="text-dark-75 font-weight-bolder">
                                                {o.title}
                                            </span>
                                            <span className="text-muted font-weight-bold">
                                                {render}
                                            </span>
                                        </div>
                                    ) : (
                                        <span
                                            className={`label  label-inline label-light-${
                                                render === "Sim"
                                                    ? "success"
                                                    : "danger"
                                            } mr-2`}
                                            key={o.key}
                                        >
                                            {o.title} - {render}
                                        </span>
                                    );
                                })}
                            </div>
                        </div>
                    ))}

                    <h4>Proponentes</h4>
                    <Table
                        columns={tableColumns}
                        data={Proponentes ?? []}
                        keyField="cod_pes"
                        noDataIndication={
                            <div className="text-center text-black-50">
                                Nenhum Proponente encontrado
                            </div>
                        }
                        bordered={false}
                        striped
                        loading={ProponentesLoading}
                        noSearch
                    />

                    <div className="row my-3">
                        <div className="col-12">
                            <InfoCobranca
                                lstCobrancasIds={venda.LstCobrancas}
                            />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="text-muted text-center">
                    Erro ao carregar informações da venda
                </div>
            )}
        </div>
    );
}
interface IFormatRender {
    key: keyof IVendaInfo;
    title: string;
    format?:
        | "date"
        | "money"
        | "percentual"
        | "flag"
        | "flagLabel"
        | ((v: any, data: IVendaInfo) => string);
}
interface ITopicDivider {
    title: string;
    data: Array<IFormatRender>;
}
const topicRender: Array<ITopicDivider> = [
    {
        title: "Valores",
        data: [
            {
                key: "ValorVenda",
                title: "Valor da Venda",
                format: "money",
            },
            {
                key: "TotalProduto",
                title: "Total do Produto",
                format: "money",
            },
            {
                key: "ValorAcrescimo",
                title: "Acréscimo",
                format: "money",
            },
            {
                key: "Desconto",
                title: "Desconto",
                format: "money",
            },
            {
                key: "ValorSeguroIncendio",
                title: "Seguro Incêndio",
                format: "money",
            },
            {
                key: "ValorCorretagem",
                title: "Corretagem",
                format: "percentual",
            },
        ],
    },
    {
        title: "Datas",
        data: [
            {
                key: "DataVenda",
                title: "Data da Venda",
                format: "date",
            },
            {
                key: "DataBaseResiduo",
                title: "Base Residuo",
                format: "date",
            },
            {
                key: "DataInicioContrato",
                title: "Início do Contrato",
                format: "date",
            },
            {
                key: "DataFimContrato",
                title: "Fim do Contrato",
                format: "date",
            },
        ],
    },
    {
        title: "Multa e Juros",
        data: [
            {
                key: "MultaAtraso",
                title: "Multa Atraso",
                format: "percentual",
            },
            {
                key: "MultaFracionada",
                title: "Multa Fracionada",
                format: "flag",
            },
            {
                key: "JurosAtraso",
                title: "Juros Atraso",
                format: "percentual",
            },
            {
                key: "JuroContrato",
                title: "Juros de Contrato",
                format: "flag",
            },
            {
                key: "JurosPorAtrasoMensal",
                title: "Juros Por Atraso Mensal",
                format: "flag",
            },
            {
                key: "AntecipacaoLinearEmJuros",
                title: "Antecipação Linear",
                format: (a, d) =>
                    d.IntExt === "I"
                        ? "Interno"
                        : a === "E"
                        ? "Externo"
                        : a
                        ? "Sim"
                        : "Não",
            },
        ],
    },
    {
        title: "Geral",
        data: [
            {
                key: "Status",
                title: "Status",
                format: (s) =>
                    s === 0
                        ? "Normal"
                        : s === 1
                        ? "Cancelada"
                        : s === 2
                        ? "Alterada"
                        : s === 3
                        ? "Quitada"
                        : s === 4
                        ? "Em acerto"
                        : "-",
            },
            {
                key: "Contrato",
                title: "Contrato",
            },
            {
                key: "Carencia",
                title: "Carência",
            },
            {
                key: "NomeVendedor",
                title: "Vendedor",
            },
            {
                key: "UsuarioReal",
                title: "Usuário UAU",
            },
            {
                key: "Adiantamento",
                title: "Adiantamento",
                format: (m) =>
                    m === 0 ? "Pró Rata" : m === 1 ? "Mensal" : "-",
            },
            {
                key: "Frequencia",
                title: "Frequência de Reajuste",
            },
            {
                key: "RetroacaoIndexador",
                title: "Retroação Indexador",
            },
            {
                key: "TipoFianca",
                title: "Tipo Fiança",
                format: (f) =>
                    f === 0
                        ? "Sem Fiança"
                        : f === 1
                        ? "Fiadores"
                        : f === 2
                        ? "Fiança Bancária"
                        : f === 3
                        ? "Caução"
                        : f === 4
                        ? "Seguro Fiança Locatária"
                        : f === 5
                        ? "Título de Capitalização"
                        : f === 6
                        ? "Carta Fiança"
                        : f === 7
                        ? "Imóvel em Garantia"
                        : "-",
            },
        ],
    },
    {
        title: "",
        data: [
            {
                key: "Amort",
                title: "Amortização",
            },
            {
                key: "BeginEnd_Vlp",
                title: "Begin End",
            },
        ],
    },
    {
        title: "",
        data: [
            {
                key: "ComPlanoIndexador",
                title: "Com Plano Indexador",
                format: "flagLabel",
            },
            {
                key: "ReajusteNaoMensal",
                title: "Reajuste Não Mensal",
                format: "flagLabel",
            },
            {
                key: "GerarResiduo",
                title: "Gerar Residuo",
                format: "flagLabel",
            },
            {
                key: "AniversarioDe",
                title: "Aniversário",
                format: "flagLabel",
            },
            {
                key: "TaxaBoleto",
                title: "Taxa de Boleto",
                format: "flagLabel",
            },
            {
                key: "ZerarCorrecaoNegativa",
                title: "Zerar Correção Negativa",
                format: "flagLabel",
            },
        ],
    },
];

const tableColumns: Array<ColumnDescription> = [
    {
        headerAlign: "center",
        dataField: "nome_pes",
        text: "Nome",
        align: "center",
    },
    {
        headerAlign: "center",
        dataField: "EmiteBoleto_CVen",
        text: "Emite Boleto",
        align: "center",
        classes: "pl-2 pr-3",
        formatter: (c, row) => <div>{c ? "Sim" : "Não"}</div>,
    },
    {
        headerAlign: "center",
        dataField: "Cliente_CVen",
        text: "Código",
        align: "center",
    },
    {
        headerAlign: "center",
        dataField: "PorcTitular_Cven",
        text: "Percentual",
        align: "center",
        formatter: (c, row) => (
            <div className="ws-nowrap">{formatPercentual(Number(c))}</div>
        ),
    },
    {
        headerAlign: "center",
        dataField: "Titular",
        text: "Titular",
        align: "center",
    },
];
